module.exports = __webpack_public_path__ + "img/d2-help-button@2x.f2b91bcb.png";